import { PYMENT } from '../../config/constants/contract';

const draftContractScheme = async document => {
  const signerObj = (props) => {
    const body = {
      nombre: props.firstName !== '' ? props.firstName : null,
      segundoNombre: props.secondName !== '' ? props.secondName : null,
      apellido: props.lastName !== '' ? props.lastName : null,
      segundoApellido: props.mLastName !== '' ? props.mLastName : null,
      rut: props.rut !== '' ? props.rut : null,
      genero: props.gender !== '' ? props.gender : null,
      nacionalidad: props.nationality !== '' ? props.nationality : null,
      estadoCivil: props.civilStatus !== '' ? props.civilStatus : null,
      profesion: props.profession !== '' ? props.profession : null,
      direccion: props.address !== '' ? props.address : null,
      comuna: props.commune !== '' ? props.commune : null,
      telefono: props.phoneNumber ? `${props.phonePrefix} ${props.phoneNumber.replace(/\s/g, '')}` : null,
      email: props.email !== '' ? props.email : null,
    };

    if (props.hasLegalPerson) {
      body.personaJuridica = {
        eud: props.companyCreationMethod ?? null,
        razon: props.businessName !== '' ? props.businessName : null,
        giro: props.giro ?? null,
        rut: props.companyRol !== '' ? props.companyRol : null,
        direccion: props.address !== '' ? props.address : null,
        comuna: props.commune !== '' ? props.commune : null,
        fechaPoder: props.dateOfconstitution ? new Date(props.dateOfconstitution).toISOString() : null,
      };
      if (!props.companyCreationMethod) {
        body.personaJuridica.notarioPoder = props.constitutionNotary !== '' ? props.constitutionNotary : null;
      }
    }
    return body;
  };

  //base data ==============================================================================================
  const data = {
    email: document.email,
    sourceUrl: document.sourceUrl,
    fecha: document.dateSign ? new Date(document.dateSign).toISOString() : null,
    lugar: document.citySign !== '' ? document.citySign : null,
    arrendador: (document.lessor && document.lessor[0]) ? signerObj(document.lessor[0]) : {},
    arrendatario: (document.lessee && document.lessee[0]) ? signerObj(document.lessee[0]) : {},
    inmueble: {
      tipo: document.typeOfHousing !== '' ? document.typeOfHousing : null,
      direccion: document.homeAddress !== '' ? document.homeAddress : null,
      comuna: document.homeCommune !== '' ? document.homeCommune : null,
    },
    arriendo: {
      fecha: document.initialLeaseDate ? new Date(document.initialLeaseDate).toISOString() : null,
      duracion: (document.contractDurationNumber && document.contractDurationRange)
        ? `${document.contractDurationNumber} ${document.contractDurationRange}`
        : null,
      autorenovacion: document.autoRenewal !== '' ? document.autoRenewal : null,
      montoMensual: document.monthlyRent !== '' ? document.monthlyRent : null,
      tipoCambio: document.typeOfCurrency !== '' ? document.typeOfCurrency : null,
      periodoPago: document.paymentPeriod !== '' ? document.paymentPeriod : null,
      montoGarantia: document.guaranteeAmount !== '' ? document.guaranteeAmount : null,
      prohibeAnimales: document.petBan !== '' ? document.petBan : null,
      sancion: document.sanction !== '' ? document.sanction : null,
    },
    tipoPago: document.paymentType !== '' ? document.paymentType : null,
    owner: {
      nombre: document.webpay_name !== '' ? document.webpay_name : null,
      rut: document.webpay_rut !== '' ? document.webpay_rut : null,
      direccion: document.webpay_address !== '' ? document.webpay_address : null,
      ciudad: document.webpay_city !== '' ? document.webpay_city : null,
      email: document.webpay_email !== '' ? document.webpay_email : null,
      telefono: document.webpay_phone !== '' ? document.webpay_phone : null,
    }
  };

  // extra lessee ==============================================================================================
  if (document.lessee.length && document.lessee[1]) {
    data.arrendatarios = document.lessee.filter((_, i) => i > 0).map(signer => {
      return signerObj(signer);
    });
  }

  //optional codebtor ==============================================================================================
  if (document.hasCodebtor) {
    data.codeudor = signerObj(document.codebtor[0]);
  };

  //optional codebtor extra data ==============================================================================================
  if (document.codebtor.length && document.codebtor[0].firstName) {
    data.codeudores = document.codebtor.filter((_, i) => i > 0).map(signer => {
      return signerObj(signer);
    });
  };

  //optional contract data ==============================================================================================
  if (document.rentAdjustment) {
    data.arriendo.tipoReajuste = document.rentAdjustment !== '' ? document.rentAdjustment : null;
    if (document.rentAdjustment === 'ipc') {
      data.arriendo.periodoReajuste = document.IPCAdjustment !== '' ? document.IPCAdjustment : null;
    }
    if (document.rentAdjustment === 'porcentaje') {
      data.arriendo.montoReajuste = document.percentAdjustment ? parseFloat(document.percentAdjustment) : null;
      data.arriendo.periodoReajuste = (document.readjustmentValue && document.readjustmentRange)
        ? `cada ${document.readjustmentValue} ${document.readjustmentRange}`
        : null;
    }
  }
  if (document.finesType) {
    data.arriendo.tipoCambioMulta = document.finesType !== '' ? document.finesType : null;
    data.arriendo.montoPenalizacion = document.finesAmount !== '' ? document.finesAmount : null;
  }
  if (document.hasParking && document.parking.length) {
    data.inmueble.listaEstacionamiento = document.parking.map(number => Object.values(number).flat(1)[0].toString());
  }
  if (document.hasWarehouse && document.warehouse.length) {
    data.inmueble.listaBodega = document.warehouse.map(number => Object.values(number).flat(1)[0].toString());
  }

  //payment data ==============================================================================================
  if (document.payCommonExpenses) {
    data.arriendo.gastosComunes = document.payCommonExpenses !== '' ? document.payCommonExpenses : null;
  }
  if (document.webpay_nameCompany) {
    data.owner.nombreEmpresa = document.webpay_nameCompany !== '' ? document.webpay_nameCompany : null;
    data.owner.giro = document.webpay_giro !== '' ? document.webpay_giro : null;
  };
  if (document.paymentType === PYMENT.TRANSFER) {
    data.cuentaPago = {
      nombre: document.holdersName !== '' ? document.holdersName : null,
      rut: document.holdersRut !== '' ? document.holdersRut : null,
      email: document.notificationEmail !== '' ? document.notificationEmail : null,
      banco: document.bank !== '' ? document.bank : null,
      tipoCuenta: document.typeBankAccount !== '' ? document.typeBankAccount : null,
      numeroCuenta: document.accountNumber !== '' ? document.accountNumber : null,
    };
  };

  return data;
};

export default draftContractScheme;
